import React from 'react';

import TextHome from '../components/TextHome';

import '../styles/Home.css';


function Home() {
    return (
        <div id="home">

            <header className="bg-white py-5">
                <TextHome />
            </header>
               
        </div>


    );
}

export default Home;